import {
  Modal,
  Paper,
  Typography,
  IconButton,
  Grid,
  Button
} from '@material-ui/core'
import { Slide } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { Skeleton } from '@material-ui/lab'

import useStyles from './styles/index.styles'

type EditCreditorModalSkeletonProps = {
  isOpen: boolean
  onClose: () => void
}

export const EditCreditorModalSkeleton = ({
  isOpen,
  onClose
}: EditCreditorModalSkeletonProps) => {
  const classes = useStyles()

  return (
    <div className={classes.modalContainer}>
      <Modal open={isOpen} onClose={onClose}>
        <Slide in={isOpen} direction="down">
          <Paper className={classes.paper}>
            {/* Header */}
            <div className={classes.header}>
              <Typography variant="h6">
                <Skeleton width={150} height={30} animation="wave" />
              </Typography>
              <IconButton>
                <CloseIcon />
              </IconButton>
            </div>

            {/* Wallet Info Skeleton */}
            <div className={classes.walletInfo}>
              {[...Array(3)].map((_, index) => (
                <div key={index} className={classes.walletInfoContent}>
                  <Skeleton width={100} height={20} animation="wave" />
                  <Skeleton width={150} height={25} animation="wave" />
                </div>
              ))}
            </div>

            {/* Amount Section Skeleton */}
            <div className={classes.amountSection}>
              <Skeleton
                variant="rect"
                width="100%"
                height={50}
                animation="wave"
                className={classes.inputSkeleton}
              />
              <Skeleton
                variant="rect"
                width="100%"
                height={50}
                animation="wave"
                className={classes.inputSkeleton}
              />
            </div>

            {/* Switches Skeleton */}
            <div className={classes.switches}>
              <Grid item xs={12} sm={4}>
                <Skeleton
                  variant="rect"
                  width={150}
                  height={40}
                  animation="wave"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Skeleton
                  variant="rect"
                  width={150}
                  height={40}
                  animation="wave"
                />
              </Grid>
            </div>

            {/* Buttons Skeleton */}
            <div className={classes.buttons}>
              <Button disabled variant="text">
                <Skeleton width={80} height={36} animation="wave" />
              </Button>
              <Button disabled variant="contained">
                <Skeleton width={80} height={36} animation="wave" />
              </Button>
            </div>
          </Paper>
        </Slide>
      </Modal>
    </div>
  )
}
